module.exports = {
  A: { api: 'A', human: 'Autorisiert' },
  B: { api: 'B', human: 'Bearbeitung' },
  N: { api: 'N', human: 'Abgelehnt' }
}
